import React from 'react';
import PropTypes from 'prop-types';

import './CompanyClaimPage.scss';

import EmployerPageLayout from '../../../../components/Employer/Layout/EmployerPageLayout/EmployerPageLayout';
import CardTitle from '../../../../components/Elements/CardTitle/CardTitle';
import Button from '../../../../components/Input/Button/Button';
import CustomerQuotesSection from '../../../../components/Employer/Marketing/CustomerQuotesSection/CustomerQuotesSection';
import EmployerLogos from '../../../../components/Employer/Marketing/EmployerLogos/EmployerLogos';
import VideoSection from '../../../../components/Employer/Marketing/VideoSection/VideoSection';
import AlternatingImageTextGrid from '../../../../components/Layout/AlternatingImageTextGrid/AlternatingImageTextGrid';
import {
    SnowplowPageViewTracker,
    PAGE_VIEW_SECTIONS,
    PAGE_VIEW_TYPES,
    PAGE_TABS,
} from '../../../../components/Analytics/Snowplow/SnowplowPageViewTracker';

import { marketingGridContent } from './constants';

const BASE_CLASS_NAME = 'page-Employer-Marketing-CompanyClaimPage';

export class CompanyClaimPage extends React.PureComponent {
    renderHeaderSection = () => {
        const { handleDemoButtonClick } = this.props;
        return (
            <section className={`${BASE_CLASS_NAME}__main-header`}>
                <CardTitle headerTag="h1" className="main-heading">
                    Claim Your Company Page on Fairygodboss
                </CardTitle>
                <p className="main-description">
                    Share your company story with our audience of 7 million
                    experienced female job seekers.
                </p>
                <Button
                    className="learn-more-cta"
                    inputStyle="purple-medium-white"
                    value="Learn more"
                    onClick={handleDemoButtonClick(
                        'claim-company-page-popup-click'
                    )}
                />
            </section>
        );
    };

    renderEmployerLogos = () => {
        const { companies } = this.props;
        return (
            <section className="sponsored-logos">
                <EmployerLogos companies={companies} />
            </section>
        );
    };

    renderFeatureBoxes = () => {
        const { handleDemoButtonClick } = this.props;
        return (
            <section className="features-section">
                <CardTitle className="features-header">
                    Tell Your Company’s Story to Millions of Female Job Seekers
                </CardTitle>
                <AlternatingImageTextGrid items={marketingGridContent} />
                <Button
                    className="learn-more"
                    inputStyle="purple-medium-white"
                    value="Learn more"
                    onClick={handleDemoButtonClick(
                        'claim-company-page-popup-click'
                    )}
                />
            </section>
        );
    };

    renderVideo = () => {
        const { videoSrc } = this.props;

        const defaultVideoSrc = 'v1/employer/Client_Success_Stories_1_ponff8';

        return (
            <section className="video-section">
                <VideoSection
                    videoSrc={videoSrc || defaultVideoSrc}
                    heading="Reach Top Female Talent with Fairygodboss"
                />
            </section>
        );
    };

    renderCustomerQuotes = () => {
        const { handleDemoButtonClick } = this.props;
        return (
            <section className="customer-quotes">
                <CustomerQuotesSection
                    onDemoButtonClick={handleDemoButtonClick(
                        'claim-company-page-popup-click'
                    )}
                />
            </section>
        );
    };

    render() {
        return (
            <React.Fragment>
                {this.renderHeaderSection()}
                {this.renderEmployerLogos()}
                {this.renderFeatureBoxes()}
                {this.renderVideo()}
                {this.renderCustomerQuotes()}
            </React.Fragment>
        );
    }
}

CompanyClaimPage.propTypes = {
    companies: PropTypes.arrayOf(
        PropTypes.shape({
            companyId: PropTypes.number.isRequired,
            url: PropTypes.string.isRequired,
            logo: PropTypes.shape({
                src: PropTypes.string,
                alt: PropTypes.string,
            }).isRequired,
        })
    ).isRequired,
    videoSrc: PropTypes.string,
    handleDemoButtonClick: PropTypes.func.isRequired,
};

CompanyClaimPage.defaultProps = {
    videoSrc: 'v1/employer/Client_Success_Stories_1_ponff8',
};

export default (props) => (
    <div className={BASE_CLASS_NAME}>
        <SnowplowPageViewTracker
            pageSection={PAGE_VIEW_SECTIONS.EMPLOYER_RESOURCES}
            pageType={PAGE_VIEW_TYPES.LANDING_PAGE}
            pageTab={PAGE_TABS.CLAIM_COMPANY}
        />
        <EmployerPageLayout PAGE_PROPS={props.PAGE_PROPS}>
            <CompanyClaimPage {...props} />
        </EmployerPageLayout>
    </div>
);
